import { render } from "./Texts.vue?vue&type=template&id=2c0a3934&scoped=true"
import script from "./Texts.vue?vue&type=script&lang=ts"
export * from "./Texts.vue?vue&type=script&lang=ts"

import "./Texts.vue?vue&type=style&index=0&id=2c0a3934&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c0a3934"

export default script